module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/links-d03d2d47d3fc5f1f576dcb68a7f692db.svg";